import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import overlayStyles from './OverlayHelpers.scss';
const HoverOnly = /*#__PURE__*/ React.forwardRef((_param, ref)=>/*#__PURE__*/ {
    var { collapseWhenHidden, reverseHidden, children, className } = _param, props = _object_without_properties(_param, [
        "collapseWhenHidden",
        "reverseHidden",
        "children",
        "className"
    ]);
    return React.createElement("div", _object_spread({
        ref: ref,
        className: classnames(overlayStyles[`hover-${reverseHidden ? 'hidden' : 'only'}${collapseWhenHidden ? '-and-collapsed' : ''}`], className)
    }, props), children);
});
HoverOnly.displayName = 'HoverOnly';
export default HoverOnly;
